import React from "react"

import {
    Box,
    ToggleButtonGroup,
} from "@mui/material"

import { Trans } from "@lingui/macro"

import withUseRouter, { UseRouterParams } from "services/router"
import {
    MatesComponent,
    MatesComponentState,
} from "components/mates-component"
import {
    FinancialPan,
    Commissions,
    CostAnalysis,
} from "components/economic"
import {
    PageHeader,
    RoutesData,
    SbToggleButton,
} from "components/commons"

interface EconomicManagementProps extends UseRouterParams
{
}
interface EconomicManagementState extends MatesComponentState
{
    financialPanChartData: {
        year: number[]
    }[]
    selectValuesFinancialPan: string[]
    costAnalysisChartData: {
        microjobs: number[]
        apis: number[]
        commissions: number[]
    }
}
class EconomicManagement extends React.Component<EconomicManagementProps, EconomicManagementState>
{
    private readonly matesComponent: MatesComponent<EconomicManagementProps, EconomicManagementState> = new MatesComponent(this)
    private readonly currentDate: Date = new Date()

    constructor(props: EconomicManagementProps) {
        super(props)
        this.state = {
            ...this.matesComponent.setupState(),
            financialPanChartData: [
                {year: [1000, 2100, 3420, 6650, 4100, 4120, 1000, 2100, 3420, 6650, 4100, 4120]},
                {year: [1250, 2000, 3000, 5500, 1250, 4000, 1250, 7000, 2547, 5500, 1250, 8000]}
            ],
            costAnalysisChartData:
                {
                    microjobs: [1500, 6200, 4300, 5700, 1200, 3300, 1500, 6200, 4300, 5700, 1200, 3300],
                    apis: [6200, 5700, 1500, 4300, 3300, 1200, 6200, 5700, 1500, 4300, 3300, 1200],
                    commissions: [4300, 3300, 5700, 1200, 6200, 1500, 4300, 3300, 5700, 1200, 6200, 1500]
                },
            selectValuesFinancialPan: [
                this.currentDate.getFullYear().toString(),
                (this.currentDate.getFullYear()-1).toString(),
                (this.currentDate.getFullYear()-2).toString(),
                (this.currentDate.getFullYear()-3).toString()
            ]
        }
    }

    render() {
        return (
            <Box sx={{pt: 2 }}>
                <PageHeader title={RoutesData.ECONOMIC_MANAGEMENT.title}
                            paths={[ RoutesData.DASHBOARD, RoutesData.ECONOMIC_MANAGEMENT ]} />
                <Box sx={{mt: 3}}>
                    <ToggleButtonGroup>
                        <SbToggleButton value="financialPan">
                            <Trans id="economic-management.finantial-pan">
                                Panoramica finanziaria
                            </Trans>
                        </SbToggleButton>
                        <SbToggleButton value="commissions">
                            <Trans id="economic-management.commissions">
                                Commissioni
                            </Trans>
                        </SbToggleButton>
                        <SbToggleButton value="cost-analysis">
                            <Trans id="economic-management.cost-analysis">
                                Analisi dei costi
                            </Trans>
                        </SbToggleButton>
                    </ToggleButtonGroup>
                </Box>
                <Box sx={{mt: 3}}>
                    <FinancialPan chartData={this.state.financialPanChartData} selectValuesFinancialPan={this.state.selectValuesFinancialPan}/>
                </Box>
                <Box sx={{mt: 6}}>
                    <Commissions />
                </Box>
                <Box sx={{mt: 3}}>
                    <CostAnalysis chartData={this.state.costAnalysisChartData}/>
                </Box>
            </Box>
        )
    }
}

export default withUseRouter(EconomicManagement)
